export const PAGINATION_DEFAULT = {
  current: 1,
  pageSize: 10
};

export const CATEGORY_ALL = 'All';
